<template>
  <PanelComponent v-if="isPanelOpened" @close="closePanel">
    <template #header>
      <h3>{{ panelTitle }}</h3>
    </template>

    <LogoSettingComponent v-if="dataPanel.name === 'logo'" />

    <HeaderSettingComponent v-if="dataPanel.name === 'header'" />

    <ActionSettingComponent v-if="dataPanel.name === 'actions'" />

    <ActionContactsSettingComponent
      v-if="dataPanel.name === 'actionContacts'"
    />

    <ContactsSettingComponent v-if="dataPanel.name === 'contacts'" />

    <RightSectionSettingComponent
      v-if="dataPanel.name === 'rightParts'"
      @closePanel="closePanel"
    />

    <QuestionPanelComponent
      v-if="
        dataPanel.name === 'question' &&
        !isContactsQuestion &&
        !isThankYouPageQuestion
      "
    />

    <ContactsFormSettingComponent
      v-if="dataPanel.name === 'question' && isContactsQuestion"
      @closePanel="closePanel"
    />

    <ThankYouPageSettingComponent
      v-if="dataPanel.name === 'question' && isThankYouPageQuestion"
      @closePanel="closePanel"
    />
  </PanelComponent>
</template>

<script lang="ts">
import {defineComponent} from "vue";

import applyIconBasic from "$images/icons/button/Name=Check, Size=16, Tone=Default.svg";
import applyIconAccent from "$images/icons/button/Name=Check, Size=16, Tone=Accent.svg";

import PanelComponent from "@/elements/UI/overlay/panel/PanelComponent.vue";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";

import LogoSettingComponent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/LogoSetting/LogoSettingComponent.vue";
import ContactsSettingComponent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/ContactsSetting/ContactsSettingComponent.vue";
import ActionSettingComponent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/ActionSetting/ActionSettingComponent.vue";
import ActionContactsSettingComponent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/ActionContactsSetting/ActionContactsSettingComponent.vue";
import RightSectionSettingComponent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/RightSectionSetting/RightSectionSettingComponent.vue";
import HeaderSettingComponent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/HeaderSetting/HeaderSettingComponent.vue";
import QuestionPanelComponent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/QuestionSetting/QuestionPanelComponent.vue";
import ContactsFormSettingComponent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/ContactsFormSetting/ContactsFormSettingComponent.vue";

import {DataPanelClues} from "@/page/quiz/typeQuiz";
import ThankYouPageSettingComponent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/ThankYouPageSetting/ThankYouPageSettingComponent.vue";

export default defineComponent({
  name: "SettingPanelComponent",

  components: {
    ThankYouPageSettingComponent,
    ContactsFormSettingComponent,
    QuestionPanelComponent,
    PanelComponent,
    PrimaryButton,
    LogoSettingComponent,
    ContactsSettingComponent,
    ActionSettingComponent,
    ActionContactsSettingComponent,
    RightSectionSettingComponent,
    HeaderSettingComponent
  },

  emits: ["closePanel"],

  data() {
    return {
      applyIconBasic,
      applyIconAccent
    };
  },

  methods: {
    closePanel(): void {
      this.$panelStore.closeSettingPanel();
      this.$emit("closePanel");
    }
  },

  computed: {
    selectedQuestion() {
      return this.$quizStore.getSelectedQuestion;
    },

    isPanelOpened(): boolean {
      return this.$panelStore.getIsShowQuestionSettingPanel;
    },

    panelTitle(): string {
      if (this.dataPanel.name === "question") {
        if (this.isContactsQuestion) {
          return "Форма контактов";
        }

        if (this.isThankYouPageQuestion) {
          return "Блок благодарности";
        }

        return "Ответ";
      }

      const titles: Record<string, string> = {
        logo: "Логотип",
        header: "Заголовок",
        actions: "Акции",
        actionContacts: "Акции",
        contacts: "Контакты",
        rightParts: "Контентный блок"
      };

      return titles[this.dataPanel.name] || "Настройки";
    },

    isContactsQuestion(): boolean {
      return this.dataPanel.category === "contacts";
    },

    isThankYouPageQuestion(): boolean {
      return this.dataPanel.category === "ThankYouPages";
    },
    dataPanel(): DataPanelClues {
      return this.$panelStore.getDataPanelClues;
    }
  },

  watch: {
    selectedQuestion() {
      this.closePanel();
    }
  }
});
</script>
